import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function DemoEntry() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        await api.demoEnter();
        await checkAuth();
      } catch (e) { /* ignore */ }
      navigate("/", { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div dir="rtl" className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-950 text-white font-body" data-testid="demo-entry">
      <Loader2 className="h-10 w-10 animate-spin text-blue-400" />
      <p className="text-lg font-heading">جارٍ تجهيز العرض التجريبي…</p>
      <p className="text-sm text-slate-400">شركة رواد التوصيل — بيانات وهمية للعرض</p>
    </div>
  );
}
